<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import type Filter from "../../models/Filter";
	import { currentItem, similarProductsGraph } from "../../scripts/stores";
	import { isNullish } from "../../../generic/scripts/functions";
	import { msg } from "../../scripts/getters";

	const dispatch = createEventDispatcher();

	export let filter: Filter;
</script>

{#if !isNullish(filter)}
	{@const { id, symbol } = filter}
	<div id={id.toString()} data-variant-filter-symbol={symbol} aria-label={msg("variant.select")} aria-required="true">
		<div class="text-gray-600 fs-8 mb-1">{filter.name}</div>
		<select class="variant" on:change|preventDefault={e => dispatch("change", { filter, value: e.currentTarget.value })}>
			{#each Array.from(filter.values) as value (value)}
				{@const activeValue = $currentItem?.hasFilterValue({ id, value, symbol })}
				{@const similarItem = !activeValue && $similarProductsGraph.hasAnySimilarItemThisValue(id, value, symbol, $currentItem)}
				<option {value} selected={activeValue} class:activeValue class:similarItem>{value}</option>
			{/each}
		</select>
	</div>
{/if}
